import { PagedResult } from './../../../model/common/paged-result';
import { Param } from './../../../model/common/param';
import { Component, EventEmitter, ViewChild } from '@angular/core';
import { GenericManage } from '../../generic/generic.manage';
import { MasterType } from '../../../model/api/assets/master-type';
import { MasterTypeHttpService } from '../../../services/http/assets/master-type.http.service';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-master-type-manage',
    templateUrl: 'master-type.manage.html',
    providers: [ MasterTypeHttpService ]
})
export class MasterTypeManageComponent extends GenericManage<MasterType, number> {

    @ViewChild('itemDetailModal') modal: ModalDirective;

    public filter: string = '';

    constructor(public masterTypeHttpService: MasterTypeHttpService) {
        super();
    }

    public detailInitialize() {
        this.modal.show();
    }

    public detailTerminate() {
        this.modal.hide();
    }

    public exportToExcel(){

        let params: Array<Param> = null;

        if ((this.filter != null) && (this.filter.length > 0)) {
            params = new Array<Param>();
            params.push(new Param('filter', this.filter));
        }

        this.masterTypeHttpService.get(1, 10000000, 'code', 'asc', params, null).subscribe(
            (data: PagedResult<MasterType>) => {

                let options = {
                    sheetid: 'mastertype',
                    headers: true,
                    column: { style: { Font: { Bold: '1' } } },
                    rows: { 1: { style: { Font: { Color: '#FF0077' } } } },
                    cells: { 1: { 1: { style: { Font: { Color: '#00FFFF' } } } } }
                };

                // alasql.promise(`SELECT id as [Id],
                //                     code as [Code],
                //                     name as [Description]
                //                     INTO XLSX("mastertype.xlsx", ?) FROM ?`, [ options, data.items ]);

            });
    }
}
